import Vue from "vue";

import Stars from "@/components/formulate/Stars";
import ViewText from "@/components/formulate/ViewText";
import Birthday from "@/components/formulate/Birthday";
import BorderBox from "@/components/formulate/BorderBox";
import SwitchBox from "@/components/formulate/SwitchBox";
import SignaturePad from "@/components/formulate/SignaturePad";
import CountryDropdown from "@/components/formulate/CountryDropdown";
import IdentityDocument from "@/components/formulate/IdentityDocument.vue";

Vue.component("Stars", Stars);
Vue.component("ViewText", ViewText);
Vue.component("Birthday", Birthday);
Vue.component("BorderBox", BorderBox);
Vue.component("SwitchBox", SwitchBox);
Vue.component("CountryDropdown", CountryDropdown);
Vue.component("IdentityDocument", IdentityDocument);

import VueSignaturePad from "vue-signature-pad";

Vue.use(VueSignaturePad);
Vue.component("SignaturePad", SignaturePad);

export default function(instance) {
    instance.extend({
        library: {
            switchbox: {
                classification: "box",
                component: "SwitchBox"
            },
            switchradio: {
                classification: "box",
                component: "SwitchBox"
            },
            borderbox: {
                classification: "box",
                component: "BorderBox"
            },
            borderradio: {
                classification: "box",
                component: "BorderBox"
            },
            viewtext: {
                classification: "text",
                component: "ViewText"
            },
            signature: {
                classification: "text",
                component: "SignaturePad"
            },
            countrydropdown: {
                classification: "select",
                component: "CountryDropdown"
            },
            birthday: {
                classification: "text",
                component: "Birthday"
            },
            stars: {
                classification: "text",
                component: "Stars"
            },
            identity_document: {
                classification: "text",
                component: "IdentityDocument"
            }
        }
    });
}
